// Powur Care for solar. From here to SOLAR_NEXT_STEPS, the copy is the V1 Solar
// brochure's, word for word.
export const SOLAR_CARE_YEARS = 30

export const SOLAR_CARE_TERMS_URL = `https://help.powur.com/hc/en-us/articles/52712651794971-Powur-Care-2-0`

export const SOLAR_CARE_BENEFITS = [
  {
    title: `Parts & labor covered 100%`,
    note: `End-to-end coverage on hardware AND on-site work.`,
  },
  { title: `$0 deductible`, note: `Never a fee to file a claim.` },
  {
    title: `Complete U.S. coverage`,
    note: `Continuous coverage if you move out-of-state.`,
  },
  {
    title: `Transferable ownership`,
    note: `Adds resale value — coverage moves with the home.`,
  },
  {
    title: `Powur-backed confidence`,
    note: `Backed by Powur, not a third-party warranty broker.`,
  },
  {
    title: `Claims handled in-house`,
    note: `One number, one team, no escalation tree.`,
  },
] as const

/** A covered system whose term is shorter than the plan's. `term` renders bold
 * between `before` and `after`. */
export type SolarCareLimitedTerm = {
  before: string
  term: string
  after: string
}

export const SOLAR_CARE_COVERAGE: readonly {
  id: string
  label: string
  icon: `battery` | `bolt` | `check` | `grid` | `home` | `panel`
  limitedTerm?: SolarCareLimitedTerm
}[] = [
  { id: `panels`, label: `Solar panels`, icon: `panel` },
  { id: `inverters`, label: `Microinverters`, icon: `bolt` },
  {
    id: `battery`,
    label: `Battery storage`,
    icon: `battery`,
    limitedTerm: {
      before: `Energy storage (battery) coverage is provided for a term of `,
      term: `twenty-five (25) years`,
      after: `, in addition to — and not in lieu of — any applicable manufacturer warranty.`,
    },
  },
  { id: `racking`, label: `Racking system`, icon: `grid` },
  {
    id: `roof`,
    label: `Roof penetration`,
    icon: `home`,
    limitedTerm: {
      before: `Roof penetration coverage is provided for a term of `,
      term: `five (5) years`,
      after: `, in addition to — and not in lieu of — any applicable contractor or manufacturer warranty.`,
    },
  },
  { id: `workmanship`, label: `Installation workmanship`, icon: `check` },
]

export const SOLAR_NEXT_STEPS = [
  {
    day: `Today`,
    title: `Approve & sign`,
    body: `E-sign your agreement from anywhere.`,
  },
  {
    day: `Week 1`,
    title: `Site survey`,
    body: `Our crew visits to verify roof, electrical, and shading.`,
  },
  {
    day: `Week 3–5`,
    title: `Permits & utility filing`,
    body: `We handle utility interconnection and city permits.`,
  },
  {
    day: `Week 6–7`,
    title: `Installation`,
    body: `One to two days on-site.`,
  },
  {
    day: `Week 8`,
    title: `Switch on`,
    body: `Your utility approves, the app activates, and you start saving.`,
  },
] as const
